import React, { useEffect, useState } from 'react';
import { dataGeoJson } from '../../data/geojson/Municipios';
import { MapContainer, TileLayer, GeoJSON } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import clienteAxios from '../../../config/clientAxios';
import { storageUrl } from '../../../config/urls';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { getCiegDocuments, normalizeCiegDocument } from '../../../services/ciegDocumentsService';

const FichasMuncipales = () => {

    const route = 'publicaciones/fichas_municipales/';
    const municipiosFallback = [
        { id: 1, file: '001_APOZOL.pdf', nombre: 'Apozol', color: '#D6F7CD' },
        { id: 2, file: '002_APULCO.pdf', nombre: 'Apulco', color: '#FFA77F' },
        { id: 3, file: '003_ATOLOLINGA.pdf', nombre: 'Atolinga', color: '#E2C9F2' },
        { id: 4, file: '004_BENITO_JUAREZ.pdf', nombre: 'Benito Juárez', color: '#FFA77F' },
        { id: 5, file: '005_CALERA.pdf', nombre: 'Calera', color: '#F7F2D2' },
        { id: 6, file: '006_CANITAS_DE_FELIPE_PESCADOR.pdf', nombre: 'Cañitas de Felipe Pescador', color: '#70A800' },
        { id: 7, file: '007_CONCEPCION_DEL_ORO.pdf', nombre: 'Concepción del Oro', color: '#E6E600' },
        { id: 8, file: '008_CUAUHTEMOC.pdf', nombre: 'Cuauhtémoc', color: '#73B2FF' },
        { id: 9, file: '009_CHALCHIHUITES.pdf', nombre: 'Chalchihuites', color: '#FFA77F' },
        { id: 10, file: '010_FRESNILLO.pdf', nombre: 'Fresnillo', color: '#E6E600' },
        { id: 11, file: '011_TRINIDAD_GARCIA_DE_LA_CADENA.pdf', nombre: 'T rinidad García de la Cadena', color: '#E2C9F2' },
        { id: 12, file: '012_GENARO_CODINA.pdf', nombre: 'Genaro Codina', color: '#FFA77F' },
        { id: 13, file: '013_GENERAL_ENRIQUE_ESTRADA.pdf.pdf', nombre: 'General Enrique Estrada', color: '#73B2FF' },
        { id: 14, file: '014_GENERAL_FRANCISCO_R_MURGUIA_NIEVES.pdf', nombre: 'General Francisco R. Murguía', color: '#73B2FF' },
        { id: 15, file: '015_EL_PLATEADO_DE_JOAQUIN_AMARO.pdf', nombre: 'El Plateado de Joaquín Amaro', color: '#D6F7CD' },
        { id: 16, file: '016_GENERAL_PANFILO_NATERA.pdf', nombre: 'General Pánfilo Natera', color: '#73B2FF' },
        { id: 17, file: '017_GUADALUPE.pdf', nombre: 'Guadalupe', color: '#CCCCCC' },
        { id: 18, file: '018_HUANUSCO.pdf', nombre: 'Huanusco', color: '#70A800' },
        { id: 19, file: '019_JALPA.pdf', nombre: 'Jalpa', color: '#FF7F7F' },
        { id: 20, file: '020_JEREZ.pdf', nombre: 'Jerez', color: '#73B2FF' },
        { id: 21, file: '021_JIMENEZ_DEL_TEUL.pdf', nombre: 'Jiménez del Teul', color: '#D6F7CD' },
        { id: 22, file: '022_JUAN_ALDAMA.pdf', nombre: 'Juan Aldama', color: '#E6E600' },
        { id: 23, file: '023_JUCHIPILA.pdf', nombre: 'Juchipila', color: '#CCCCCC' },
        { id: 24, file: '024_LORETO.pdf', nombre: 'Loreto', color: '#E6E600' },
        { id: 25, file: '025_LUIS_MOYA.pdf', nombre: 'Luis Moya', color: '#E2C9F2' },
        { id: 26, file: '026_MAZAPIL.pdf', nombre: 'Mazapil', color: '#70A800' },
        { id: 27, file: '027_MELCHOR_OCAMPO.pdf', nombre: 'Melchor Ocampo', color: '#73B2FF' },
        { id: 28, file: '028_MEZQUITAL_DEL_ORO.pdf', nombre: 'Mezquital del Oro', color: '#73B2FF' },
        { id: 29, file: '029_MIGUEL_AUZA.pdf', nombre: 'Miguel Auza', color: '#D6F7CD' },
        { id: 30, file: '030_MOMAX.pdf', nombre: 'Momax', color: '#73B2FF' },
        { id: 31, file: '031_MONTE_ESCOBEDO.pdf', nombre: 'Monte Escobedo', color: '#70A800' },
        { id: 32, file: '032_MORELOS.pdf', nombre: 'Morelos', color: '#D6F7CD' },
        { id: 33, file: '033_MOYAHUA_DE_ESTRADA.pdf', nombre: 'Moyahua de Estrada', color: '#D6F7CD' },
        { id: 34, file: '034_NOCHISTLAN_DE_MEJIA.pdf', nombre: 'Nochistlán de Mejía', color: '#E6E600' },
        { id: 35, file: '035_NORIA_DE_ANGELES.pdf', nombre: 'Noria de Ángeles', color: '#FFA77F' },
        { id: 36, file: '036_OJOCALIENTE.pdf', nombre: 'Ojocaliente', color: '#70A800' },
        { id: 37, file: '037_PANUCO.pdf', nombre: 'Pánuco', color: '#BFECF5' },
        { id: 38, file: '038_PINOS.pdf', nombre: 'Pinos', color: '#CCCCCC' },
        { id: 39, file: '039_RIO_GRANDE.pdf', nombre: 'Río Grande', color: '#CCCCCC' },
        { id: 40, file: '040_SAIN_ALTO.pdf', nombre: 'Sain Alto', color: '#F7F2D2' },
        { id: 41, file: '041_EL_SALVADOR.pdf', nombre: 'El Salvador', color: '#FFA77F' },
        { id: 42, file: '042_SOMBRERETE.pdf', nombre: 'Sombrerete', color: '#70A800' },
        { id: 43, file: '043_SUSTICACAN.pdf', nombre: 'Susticacán', color: '#F7F2D2' },
        { id: 44, file: '044_TABASCO.pdf', nombre: 'Tabasco', color: '#E6E600' },
        { id: 45, file: '045_TEPECHITLAN.pdf', nombre: 'Tepechitlán', color: '#73B2FF' },
        { id: 46, file: '046_TEPETONGO.pdf', nombre: 'Tepetongo', color: '#BFECF5' },
        { id: 47, file: '047_TEUL_DE_GONZALEZ_ORTEGA.pdf', nombre: 'Teúl de González Ortega', color: '#E6E600' },
        { id: 48, file: '048_TLALTENANGO_DE_SANCHEZ_ROMAN.pdf', nombre: 'Tlaltenango de Sánchez Román', color: '#CCCCCC' },
        { id: 49, file: '049_VALPARAISO.pdf', nombre: 'Valparaíso', color: '#E2C9F2' },
        { id: 50, file: '050_VETAGRANDE.pdf', nombre: 'Vetagrande', color: '#E6E600' },
        { id: 51, file: '051_VILLA_DE_COS.pdf', nombre: 'Villa de Cos', color: '#FFA77F' },
        { id: 52, file: '052_VILLA_GARCIA.pdf', nombre: 'Villa García', color: '#D6F7CD' },
        { id: 53, file: '053_VILLA_GONZALEZ_ORTEGA.pdf', nombre: 'Villa González Ortega', color: '#D6F7CD' },
        { id: 54, file: '054_VILLA_HIDALGO.pdf', nombre: 'Villa Hidalgo', color: '#F7F2D2' },
        { id: 55, file: '055_VILLANUEVA.pdf', nombre: 'Villanueva', color: '#E2C9F2' },
        { id: 56, file: '056_ZACATECAS.pdf', nombre: 'Zacatecas', color: '#70A800' },
        { id: 57, file: '057_TRANCOSO.pdf', nombre: 'Trancoso', color: '#F7F2D2' },
        { id: 58, file: '058_SANTA_MARIA_DE_LA_PAZ.pdf', nombre: 'Santa María de la Paz', color: '#70A800' },
    ];


    const [municipio, setMunicipio] = useState({});
    const [selected, setSelected] = useState({});
    const [loading, setLoading] = useState(false);
    const [municipiosDb, setMunicipiosDb] = useState([]);
    const municipios = municipiosDb.length > 0 ? municipiosDb : municipiosFallback;

    useEffect(() => {
        getCiegDocuments('publicaciones/fichas_municipales')
            .then((data) => {
                const documents = data.map(normalizeCiegDocument)
                    .filter((document) => document.metadata.source_id)
                    .map((document) => ({
                        id: parseInt(document.metadata.source_id),
                        nombre: document.title,
                        file: document.file,
                        file_path: document.file,
                        color: document.metadata.color || '#CCCCCC'
                    }));

                if (documents.length > 0) {
                    setMunicipiosDb(documents);
                }
            })
            .catch((error) => console.log(error));
    }, []);

    const getMunicipio = (id) => municipios.filter(r => r.id == id)[0] || {};
    const getFilePath = (item) => item.file_path || (item.file && item.file.includes('/') ? item.file : `${route}${item.file}`);

    const downFile = () => {
        setLoading(true);
        const file = getFilePath(selected);
        clienteAxios.post('pdf', { file: file }, {
            responseType: 'blob',
        }).then(get => {
            const url = URL.createObjectURL(new Blob([get.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
                'download',
                `${file.split('/').pop()}`
            );
            document.body.appendChild(link);
            link.click();
        }).catch(error => {
            console.log(error);
        }).finally(() => {
            setLoading(false);
        });
    }

    return (
        <React.Fragment>
            <div className='row'>
                <div className='col-md-12' style={{ textAlign: 'center' }}>
                    <h2>Cédula de Información Básica Municipal</h2>
                </div>
            </div>
            <div className='row'>
                <div className='col-md-4'></div>
                <div className='col-md-8'>
                    <div className='row'>
                        <div className="col-md-10" style={{ textAlign: 'center' }}>
                            {selected.id ? <h5><i>Municipio {selected.id}.-{selected.nombre}</i></h5> : <h5>&nbsp;</h5>}
                        </div>
                        {selected.id &&
                            <div className='col-md-2'>
                                <button type='button' className='btn btn-danger btn-sm' onClick={() => downFile()} disabled={loading}>
                                    Descargar <FontAwesomeIcon icon={faDownload} />
                                </button>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col-md-4'>
                    <div className='mapa'>
                        <MapContainer style={{ "width": "32vw", "height": "82vh" }} center={['22.818146', '-102.458302']} zoom={7} minZoom={6} maxZoom={11} touchZoom={-1} zoomControl={true} scrollWheelZoom={false}>
                            <TileLayer attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors' url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' />
                            <div className="leaflet-top leaflet-right">
                                <div className="info leaflet-control text-center" style={{ padding: '6px 8px', font: '14px/16px Arial, Helvetica, sans-serif', background: 'white', boxShadow: '0 0 15px rgba(0,0,0,0.2)', borderRadius: '5px', opacity: 0.7 }}>
                                    <h6 style={{ color: '#777' }}>Zacatecas, México</h6>
                                    {municipio.id &&
                                        <div>
                                            <strong>{municipio.id} - {municipio.nombre}</strong><br></br>
                                            <label>Municipio</label>
                                        </div>
                                    }
                                </div>
                            </div>
                            {dataGeoJson.features.map(dato => {
                                return (
                                    <GeoJSON
                                        key={dato.properties.CVE_MUN}
                                        data={dato}
                                        eventHandlers={{
                                            mouseover: (e) => {
                                                e.layer.setStyle({
                                                    fillOpacity: 1
                                                });
                                                var contentPopUp = `<strong>${parseInt(dato.properties.CVE_MUN)}.-${dato.properties.NOMGEO}</strong>`;
                                                e.propagatedFrom.bindTooltip(contentPopUp).openTooltip();
                                                setMunicipio({
                                                    id: parseInt(dato.properties.CVE_MUN),
                                                    clave: dato.properties.CVEGEO,
                                                    nombre: dato.properties.NOMGEO
                                                });
                                            },
                                            mouseout: (e) => {
                                                setMunicipio({});
                                                e.layer.setStyle({
                                                    fillOpacity: 0.6
                                                });
                                            },
                                            click: (e) => {
                                                setSelected(getMunicipio(parseInt(dato.properties.CVE_MUN)));
                                            },
                                        }}
                                        color={'white'}
                                        fillColor={getMunicipio(parseInt(dato.properties.CVE_MUN)).color || '#CCCCCC'}
                                        fillOpacity={0.6}
                                        dashArray={'3'}>
                                    </GeoJSON>
                                );
                            })}
                        </MapContainer>
                    </div>
                </div>
                <div className='col-md-8' style={{ textAlign: 'center' }}>
                    {selected.id ?
                        <iframe title={selected.file} src={`${storageUrl(getFilePath(selected))}#toolbar=0`} width="100%" height="100%" frameBorder="1"></iframe> :
                        <div width="100%" height="100%" style={{ marginRight: '1rem', marginTop: '8rem' }}>
                            <h5>
                                <i style={{ color: 'gray' }}>
                                    Documentos compilatorios de información estadística básica de diversas fuentes sobre los siguientes temas:<br />
                                    <br />
                                    <strong>1.-</strong> ASPECTOS DEMOGRÁFICOS<br />
                                    <strong>2.-</strong> INFORMACIÓN ECONÓMICA<br />
                                    <strong>3.-</strong> CARACTERÍSTICAS EDUCATIVAS<br />
                                    <strong>4.-</strong> CARACTERÍSTICAS DE SALUD<br />
                                    <strong>5.-</strong> VÍAS DE COMUNICACIÓN<br />
                                    <strong>6.-</strong> INFRAESTRUCTURA BÁSICA Y MARGINACIÓN<br />
                                    <strong>7.-</strong>AGRICULTURA Y GANADERÍA<br />
                                    <strong>8.-</strong> INFRAESTRUCTURA Y MEDIO AMBIENTE<br />
                                    <strong>9.-</strong> DELITOS DEL FUERO COMÚN<br />
                                    <br />
                                    Presionar sobre el mapa en el municipio de su interés para mostrar la Ficha correspondiente.
                                </i>
                            </h5>
                        </div>
                    }
                </div>
            </div>
            <br />
            <br />
        </React.Fragment>
    );
}

export default FichasMuncipales;
